// payments views
import Payments from '@/views/Payments.vue';

import PaymentsDashboard from '@/views/Payments/PaymentsDashboard.vue';
import PaymentsReview from '@/views/Payments/PaymentsReview.vue';
import PaymentsHistory from '@/views/Payments/PaymentsHistory.vue';
import PaymentInfo from '@/views/Payments/PaymentInfo.vue';
import CpaConversions from '@/views/Payments/CpaConversions.vue';
import ExternalPayments from '@/views/Payments/ExternalPayments.vue';

export default [
  {
    path: '/payments',
    component: Payments,
    meta: {
      requiresAuth: true,
      view: 'payments',
    },
    children: [
      {
        path: 'dashboard',
        component: PaymentsDashboard,
        name: 'payments.dashboard',
        meta: {
          view: 'dashboard',
        },
      },
      {
        path: 'moderation/:status',
        component: PaymentsReview,
        name: 'payments.moderation',
        meta: {
          view: 'moderation',
        },
      },
      {
        path: 'payout/:status',
        component: PaymentsHistory,
        name: 'payments.payout',
        meta: {
          view: 'payout',
        },
      },
      {
        path: 'info/:id',
        component: PaymentInfo,
        name: 'payments.info',
      },
      {
        path: 'external',
        component: ExternalPayments,
        name: 'payments.external',
        meta: {
          view: 'external',
        },
      },
      {
        path: 'cpa-conversions',
        component: CpaConversions,
        name: 'payments.cpa-conversions',
      },
      {
        path: '',
        name: 'payments.empty',
        redirect: {
          name: 'payments.dashboard',
        },
      },
      {
        path: ':catchAll(.*)',
        name: 'payments.catch-all',
        redirect: {
          name: 'payments.dashboard',
        },
      },
    ],
  },
];
